import React, { useEffect, useState, useContext } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Link } from 'react-router-dom';
import ApiCall from '../../utils/Api';
import { toast } from 'react-toastify';
import { Button } from '@mui/material';
import Swal from 'sweetalert2';
import {convertDateFormat,extractTimeFromTimestamp} from "../../utils/services";
import screens from '../../screens';
import components from '../../components';
import { LangContext } from '../../utils/contaxt';
function createData(name, code,address, price, units,Revenue) {
  return { name, code, address, price, units,Revenue };
}
// const [changeColor,setchangeColor]=useState("")
const row ={Balance:'Sep 26, 2023 8:26 AM ET',TDU:"NOR-FX-TDU-6M-FWD-2023-09-26", USD:6000}

export default function ProviderProfileTable() {
  const { lang, first_Name, Last_Name, setlang, setfirst_Name, setLast_Name } = useContext(LangContext);
  const [WalletAddresses,setWalletAddresses]=useState()
  const [UpdateCount,setUpdateCount]=useState(0)
  const [latestTransaction, setLatestTransaction] = useState(null);

  const viewAccounts = async () => {
    try {
      // Get wallet addresses from API (this works without MetaMask connection)
      const data = await ApiCall.SECURE_API.get("/user/GetWalletAddresses");
      
      let WalletsIds = data.data.data || [];
      let connectedAccounts = [];
      
      // Try to get connected accounts from MetaMask (only if available)
      if (window.ethereum) {
        try {
          connectedAccounts = await window.ethereum.request({ method: 'eth_accounts' });
        } catch (error) {
          // MetaMask is not connected, but we can still show wallet addresses
        }
      }
      
      // Show wallet addresses dialog (keeping original style)
      Swal.fire({
        title: "Wallet Addresses",
        html: `
          <div style="max-height: 400px; overflow-y: auto; padding: 30px">
            <ul style="list-style-type: none; padding: 0; margin: 0;">
              ${WalletsIds.map((item) => {
                const isConnected = connectedAccounts.some((item2) => item2.toLowerCase() === item.toLowerCase());
                const statusHTML = isConnected 
                  ? '<span style="font-size: 12px;">Connected</span>'
                  : '';
                return `<li style="margin-bottom: 10px; display: flex; justify-content: space-between; align-items: center;">
                  <span>${item}</span>
                  ${statusHTML}
                </li>`;
              }).join("")}
            </ul>
          </div>
        `,
        width: '800px',
        showCloseButton: true,
        showConfirmButton: false,
      });
      
    } catch (error) {
      toast.error("Failed to load wallet addresses");
    }
  }
const getLatestTransaction = async (userId) => {
  try {
    const res = await ApiCall.SECURE_API.get(`/latestTransaction/${userId}`);
    
    if (res.data.data && res.data.data.transactionDate) {
      setLatestTransaction(res.data.data.transactionDate);
    } else {
      setLatestTransaction(null);
    }
  } catch (err) {
    setLatestTransaction(null);
  }
};


     const [ConsumerData,setConsumerData]=useState({})

     const getConsumerData=async()=>{
          try {
               const data=await ApiCall.SECURE_API.get("/provider/profile")
               const profileData = data.data.data;
               setConsumerData(profileData)
               
               // Set profile data in context for header display
               if (profileData?.profileImage) {
                 setlang(profileData.profileImage);
                 localStorage.setItem("image", profileData.profileImage);
               } else {
                 // Check if there's an image in localStorage as fallback
                 const storedImage = localStorage.getItem("image");
                 if (storedImage) {
                   setlang(storedImage);
                 }
               }
               
               // Use institutionName as the display name since firstName/lastName are not available
               if (profileData?.institutionName) {
                 setfirst_Name(profileData.institutionName);
                 setLast_Name(""); // Clear lastName since it's not available
               }
               
               // Now fetch latest transaction using user ID
               getLatestTransaction(profileData?._id);
          } catch (error) {
               if (error?.response?.data?.message) {
                    toast.error(error.response.data.message);
                  } else {
                    toast.error(error.message);
                  }
          }

     }
    useEffect(() => {
      getConsumerData();
    }, [UpdateCount])
    useEffect(() => {
  if (ConsumerData?._id) {
    getLatestTransaction(ConsumerData._id);
  }
}, [ConsumerData]);
  
    function formatEtherFromWei(weiValue, decimalPlaces) {
      // Convert wei to ether using Web3.js utility function
      const etherValue = web3.utils.fromWei(weiValue, "ether");
  
      // Limit the ether value to a specified number of decimal places
      const formattedEther = parseFloat(etherValue).toFixed(decimalPlaces);
  
      // Return the formatted ether value with "ETH" appended
      return formattedEther + " ETH";
  }
  return (
    <TableContainer style={{borderRadius:9}} component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead style={{backgroundColor:"Black"}}>
          <TableRow>
          <TableCell align="center" style={{color:"white"}}>Created At</TableCell>
          <TableCell align="center" style={{color:"white"}}>Name</TableCell>
          <TableCell align="center" style={{color:"white"}}>Code</TableCell>
            <TableCell align="center" style={{color:"white"}}>Email</TableCell>
            <TableCell align="center" style={{color:"white"}}>Last Fund Transaction</TableCell>
            <TableCell align="center" style={{color:"white"}}></TableCell>
            <TableCell align="center" style={{color:"white"}}></TableCell>

            {/* <TableCell align="center" style={{color:"white"}}>Connected Wallet</TableCell> */}

            {/* <TableCell align="right">Carbs&nbsp;(g)</TableCell>
            <TableCell align="right">Protein&nbsp;(g)</TableCell> */}
          </TableRow>
        </TableHead>
        <TableBody>
     
            <TableRow
              key={row.Balance}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              
            >   <TableCell align="center">
            <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>


              <div style={{ display: "flex", flexDirection: "column" ,alignItems:"flex-start"}}> 
              <span style={{fontWeight:600}}> {convertDateFormat(ConsumerData?.createdAt)}</span><span style={{color:"gray"}}> {extractTimeFromTimestamp(ConsumerData?.createdAt)}</span>             
              </div>
              </div>
          </TableCell>
          <TableCell align="center">
                {ConsumerData?.institutionName}
              </TableCell>
          <TableCell align="center">
                {ConsumerData?.institutionCode}
              </TableCell>
            
              <TableCell align="center">{ConsumerData?.email}</TableCell>
            <TableCell align="center">
  {latestTransaction ? (
    <>
      <span style={{ fontWeight: 600 }}>{convertDateFormat(latestTransaction)}</span><br />
      <span style={{ color: "gray" }}>{extractTimeFromTimestamp(latestTransaction)}</span>
    </>
  ) : (
    "No Transaction"
  )}
</TableCell>


              {/* <TableCell align="center"><img height={80} src={ConsumerData?.profileImage}/> </TableCell> */}

              
              
              <TableCell align="center">
                <Button
                onClick={() =>{
                  viewAccounts()
                }}
                >View Accounts</Button>
              </TableCell>
              <TableCell align="center">
                <components.Provider_Permissions_Detail_Dialog.providerEditImage
                  setUpdateCount={setUpdateCount}
                  UpdateCount={UpdateCount}
                  imgurl={ConsumerData.profileImage}
                  firstName={ConsumerData.institutionName || ConsumerData.firstName}
                  lastName={ConsumerData.lastName}
                  email={ConsumerData.email}
                />
              </TableCell>

              {/* <TableCell align="center">{ConsumerData.walletAddress?.map((item)=>item)}</TableCell> */}

              

            </TableRow>
     
        </TableBody>
      </Table>
    </TableContainer>
  );
}